/**
 * Environment predicates. MUST derive from `import.meta.env` — never `import process from
 * "process"`: that import binds Vite's empty browser stub, SHADOWING the compile-time define of
 * `process.env.NODE_ENV`, and the module-eval TypeError aborts hydrateRoot for the whole app
 * (ui#172 — prod interactivity outage once ui#169 made this module eager).
 */
const development: boolean = import.meta.env.DEV;

export function isDev(): boolean {
	return development;
}

export function isProd(): boolean {
	return !isDev();
}
